import {Text} from '@eitje/web_components'

export const TranslationCell = ({getValue}) => {
	const value = getValue()
	return <Text style={{display: 'inline-flex'}} t={value} />
}
